var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIconLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "download",
    d: "M22.9,15.2a1.1,1.1,0,0,0-1.1,1.1v4.4a1.1,1.1,0,0,1-1.1,1.1H5.3a1.1,1.1,0,0,1-1.1-1.1V16.3a1.1,1.1,0,1,0-2.2,0v4.4A3.3,3.3,0,0,0,5.3,24H20.7A3.3,3.3,0,0,0,24,20.7V16.3A1.1,1.1,0,0,0,22.9,15.2ZM12.219,17.081a1.1,1.1,0,0,0,.363.231,1.034,1.034,0,0,0,.836,0,1.1,1.1,0,0,0,.363-.231l4.4-4.4a1.1,1.1,0,0,0-1.562-1.562L14.1,13.649V3.1a1.1,1.1,0,0,0-2.2,0V13.649l-2.519-2.53a1.1,1.1,0,0,0-1.562,1.562Z",
    transform: "translate(-2 -2)",
    fill: "#888b8d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconLight);
export default __webpack_public_path__ + "static/media/downloadIcon_light.1ea3d98196ecb61a8f985548e050a6f7.svg";
export { ForwardRef as ReactComponent };